export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'documentCategoryId',
    label: 'Category',
  },
];

export const columnsLabels = {};

export const schema = {};

export const defaultSorter = {};
